//console.log("Custom Popup Video Started");

//get the time from admin shopify
const milisecondsToShow = $('#popup-video').data('miliseconds-to-show');

//get the hours to show again from admin shopify
const hoursToShow = $('#popup-video').data('show-after-hours');

//put the name of this store
const storeName = 'ToucheInt';

//cookie name when close the popup
const KEY_POPUP = `lastClosedPopupVideo${storeName}`;

//search the cookie if exist in Application memory
const lastClosed = localStorage.getItem(KEY_POPUP);

const startDate = $('#popup-video').data('start-date');
const endDate = $('#popup-video').data('end-date');


const shopUrl = $('#popup-video').data('shop-name') + "/";
const onlyInHome = $('#popup-video').data('show-in-home');

window.addEventListener('DOMContentLoaded', (event) => {

    var now = moment(new Date());
    var lastTime = moment(lastClosed);

    var sinceDate = moment(startDate, 'YYYY/MM/DD').format('YYYYMMDD');
    var toDate = moment(endDate, 'YYYY/MM/DD').format('YYYYMMDD');
    var today = moment(new Date()).format('YYYYMMDD');

    if(today >= sinceDate && today <= toDate){

        if(!onlyInHome){
            setTimeout(() => {
                if((!lastClosed || now.diff(lastTime, 'hours') >= hoursToShow)){
                    $('#popup-video').fadeIn();
                    $("html").addClass("block-scroll");
                }
            }, milisecondsToShow);
        }
        else if(onlyInHome && window.location.href == shopUrl){
            setTimeout(() => {
                if((!lastClosed || now.diff(lastTime, 'hours') >= hoursToShow)){
                    $('#popup-video').fadeIn();
                    $("html").addClass("block-scroll");
                }
            }, milisecondsToShow);
        }
    }
});


$('.close-popup-video').click(function (e) { 
    e.preventDefault();
    localStorage.setItem(KEY_POPUP, moment(new Date()).toString());
    $('#popup-video').fadeOut();
    $("html").removeClass("block-scroll");
});



const buttonSubmit = document.querySelector('.link-popup-video a');

$(buttonSubmit).click(function (event) {
    localStorage.setItem(KEY_POPUP, moment(new Date()).toString());
    $('#popup-video').fadeOut();
    $("html").removeClass("block-scroll");
});

